/**
 * @author mygi
 */
import * as React from 'react';
import { Dialog } from '@shared/ui-react/Dialog';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { FilesDownload } from '@shared/files/FilesDownload';


export const FilesDownloadDialog = {
    open: (opts: {
        uuid: string
    }) => {
        const targetEl = document.getElementById('react-portal-root');

        ReactUtils.safeRender(<>
            <Dialog onClose={FilesDownloadDialog.close} title={kuura.getMessage('js_files.download_btn')}>
                <div className='padded flex-column' style={{width: 600, overflow: 'hidden'}}>
                    <FilesDownload
                        uuid={opts.uuid}
                    />
                </div>
            </Dialog>
        </>, targetEl);
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },
};
